// From: https://github.com/thejameskyle/react-required-if
module.exports = function requiredIf(type, condition) {
  return function(props) {
    let test = condition(props) ? type.isRequired : type;
    return test.apply(this, arguments);
  };
};


// WEBPACK FOOTER //
// ./src/shared/functions/requiredIf.js